
export default {
  name: 'AppReviewMediaThumbnailIndicator',
  props: {
    review: { type: Object, required: true },
    currentIndex: { type: Number, default: 0 },
    videoEagerLoading: { type: Boolean, default: false }
  }
};
